import { render, staticRenderFns } from "./scroll-down.vue?vue&type=template&id=3869d78e&"
import script from "./scroll-down.vue?vue&type=script&lang=js&"
export * from "./scroll-down.vue?vue&type=script&lang=js&"
import style0 from "./scroll-down.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports